module.exports = __webpack_public_path__ + "img/table-icon-comercial.0c6a7627.png";